import React, { useEffect, useState, useCallback } from "react";
import { Link } from "react-router-dom";
import { listValorcarMovements } from "../../services/valorcarServices";

// Bell ligeiro no Header — só aparece quando há movements Valorcar
// em status `pending` por preencher. Click leva directo a /valorcar.
// Polling a cada 90s; falhas silenciosas (típico se módulo desactivo).
const POLL_INTERVAL_MS = 90 * 1000;

const ValorcarBell = () => {
  const [count, setCount] = useState(0);
  const [reversalCount, setReversalCount] = useState(0);

  const load = useCallback(async () => {
    try {
      const [pending, reversal] = await Promise.all([
        listValorcarMovements({
          status: "pending",
          is_reversal: 0,
          limit: 1,
        }),
        listValorcarMovements({
          status: "pending",
          is_reversal: 1,
          limit: 1,
        }),
      ]);
      setCount(pending?.data?.data?.total || 0);
      setReversalCount(reversal?.data?.data?.total || 0);
    } catch (_) {
      // silencioso (módulo off ou sem permissão)
    }
  }, []);

  useEffect(() => {
    load();
    const id = setInterval(load, POLL_INTERVAL_MS);
    return () => clearInterval(id);
  }, [load]);

  const total = count + reversalCount;
  if (total === 0) return null;

  const accentColor = "#0d8484"; // teal Valorcar

  return (
    <li
      className="nav-item dropdown hoverDropdown"
      style={{ marginRight: "8px" }}
    >
      <Link
        to="/valorcar"
        className="btn btn-block"
        title={`${total} movimento${total === 1 ? "" : "s"} Valorcar pendente${total === 1 ? "" : "s"}`}
        style={{
          width: "auto",
          minWidth: 44,
          padding: "6px 10px",
          background: accentColor,
          color: "#fff",
          border: `1px solid ${accentColor}`,
          position: "relative",
          display: "inline-flex",
          alignItems: "center",
          gap: 6,
        }}
      >
        <i className="bi bi-recycle" style={{ fontSize: 18 }}></i>
        <span style={{ fontWeight: 700 }}>{total}</span>
        {reversalCount > 0 && (
          <span
            title={`${reversalCount} reversão${reversalCount === 1 ? "" : "ões"}`}
            style={{
              fontSize: 10,
              background: "#ffc107",
              color: "#000",
              padding: "1px 5px",
              borderRadius: 8,
              fontWeight: 700,
            }}
          >
            ↩{reversalCount}
          </span>
        )}
      </Link>
    </li>
  );
};

export default ValorcarBell;
